export default __webpack_public_path__ + "static/media/default_building.dfd17ae0.png";